export default __webpack_public_path__ + "static/media/team.2fab22c6.svg";